module.exports = __webpack_public_path__ + "img/svg/energy-drink-stats.94d874b6e1d59f6d801430b3060e575e.svg";